import React from "react";
import { Link } from "react-router-dom";
import { TaskTypeForm } from "./TaskTypeForm";

export default class CreateTaskType extends React.Component {
  render() {
    return (
      <>
        <ul className="breadcrumb">
          <li>
            <Link to="/admin">Admin</Link>
          </li>
          <li>
            <Link to="/admin/project-types">Types de tâches</Link>
          </li>
          <li className="active">Créer un type de tâches</li>
        </ul>

        <div className="page-title">
          <h2>
            <span className="fa fa-arrow-circle-o-left" /> Créer un type de
            tâches
          </h2>
        </div>

        <div className="page-content-wrap">
          <div className="panel panel-default">
            <div className="panel-body">
              <p>
                Indiquer les informations suivantes pour créer votre type de
                tâches
              </p>
            </div>
            <div className="panel-body form-group-separated">
              <TaskTypeForm />
            </div>
          </div>
        </div>
      </>
    );
  }
}
